<template>
	<ja-modal class="add-student-modal" :show="show">
		<ja-close-button
			class="close-button-new-student"
			name="close"
			@click.native="closeModalNewUser"
		></ja-close-button>

		<div class="modal-content-wrapper">
			<h3 class="title-modal">{{ $t('addNewStudent') }}</h3>
			<div v-show="showImportInfo" class="import-info">
				<div class="import-info body-text-2">{{ $t('importInfo') }}</div>
				<div
					v-if="showFileExtensionWarning"
					class=" import-result-failed-messages"
				>
					{{ $t('fileExtensionWarning') }}
				</div>
				<div v-if="importResult" class="import-info-panel">
					<div v-if="!importResult.maxFileError">
						<div class="import-result-container">
							<div v-if="importResult" class="import-result-imported">
								<svgicon name="info" class="info"></svgicon>
								{{
									$t('importResultImported', {
										imported: importResult.importedCount
									})
								}}
							</div>
							<div v-if="importResult" class="import-result-failed">
								<svgicon name="info" class="info"></svgicon>
								{{
									$t('importResultFailed', {
										failed: importResult.failedCount
									})
								}}
							</div>
						</div>
						<div
							v-if="importResult && importResult.invalidRows.length"
							class="import-result-failed-messages"
						>
							{{ $t('invalidRows') }}
							<span>{{ importResult.invalidRows | arrayToString }}</span>
						</div>
					</div>
					<div v-else class="import-result-failed-messages">
						{{ $tc('fileMaxLinesError', FILE_MAX_LINES) }}
					</div>
				</div>
			</div>

			<div class="modal-content">
				<perfect-scrollbar class="scrollbar">
					<div v-if="studentData && studentData.length" class="fields-new-user">
						<div
							v-for="(n, index) in studentData"
							:key="n.entityGuid"
							class="new-user-row"
						>
							<ja-add-student-form
								ref="studentForm"
								:validation-check="validationCheck"
								:entity-guid="n.entityGuid"
								@update="updateListObject($event, index)"
							></ja-add-student-form>
							<div
								v-if="index > 0"
								class="delete-student-field"
								@click="deleteStudentField(index)"
							>
								<svgicon class="svg-delete" name="delete"></svgicon>
								{{ $t('delete') }}
							</div>
						</div>
						<ja-alert-bar
							class="alert-bar-students"
							:alert-condition="alertIsVisible"
							>{{ $t('adminStudentsError') }}</ja-alert-bar
						>

						<ja-alert-bar
							class="alert-bar-students"
							:alert-condition="serverErrorMessageIsVisible"
							>{{ serverErrorMessage }}</ja-alert-bar
						>
						<div class="new-user-buttons">
							<ja-button
								name="add-another-student"
								class="small outlined add-another-student"
								@click.native="addToList"
								>{{ $t('addAnotherStudent') }}</ja-button
							>

							<ja-button
								name="done"
								class="small btn-done-add-student"
								:disabled="requestMade"
								@click.native="saveStudents"
								>{{ $t('done') }}</ja-button
							>
						</div>
					</div>
					<div v-else>
						<ja-button name="add-new" class="small" @click.native="addToList">{{
							$t('addNew')
						}}</ja-button>
						<ja-button
							name="import"
							class="small outlined btn-import"
							@click.native="handleFileUpload"
							>{{ $t('import') }}</ja-button
						>

						<input
							id="file-upload"
							ref="file"
							type="file"
							@change="startUpload($event)"
						/>
					</div>
				</perfect-scrollbar>
			</div>
		</div>
	</ja-modal>
</template>

<script>
import '../../icons/expenseCategories';
import '@/components/icons/plus';
import '@/components/icons/info';
import Button from '../../ui/Button';
import { fileConfigSettings } from '@/helpers/constants';

import AddStudentForm from '../forms/AddStudentForm';
import Modal from '@/components/Modal/Modal';
import AlertBar from '@/components/ui/AlertBar';
import gql from 'graphql-tag';
import axios from 'axios';
import CloseButton from '../../ui/CloseButton';

import { validateFileMaxLines } from '@/helpers/utils';

export default {
	components: {
		jaAddStudentForm: AddStudentForm,
		jaButton: Button,
		jaModal: Modal,
		jaAlertBar: AlertBar,
		jaCloseButton: CloseButton
	},
	filters: {
		arrayToString(value) {
			return value.join(', ');
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			showFileExtensionWarning: false,
			alertIsVisible: false,
			showImportInfo: true,
			importResult: null,
			importResultPartitions: null,
			serverErrorMessage: null,
			studentData: [],
			requestMade: false,
			validationCheck: false,
			serverErrorMessageGuid: null,
			studentFormData: [],
			FILE_MAX_LINES: fileConfigSettings.FILE_MAX_LINES
		};
	},
	computed: {
		fileInput() {
			return document.getElementById('file-upload');
		},
		constants() {
			return this.$store.getters.constants;
		},
		emailRegex() {
			if (this.constants && this.constants.emailRegex) {
				return this.constants.emailRegex;
			}
			return null;
		},
		serverErrorMessageIsVisible() {
			return !!this.serverErrorMessage;
		}
	},
	methods: {
		generateEntityGuid() {
			function generateString(dash) {
				var p = (Math.random().toString(16) + '000000000').substr(2, 8);
				return dash ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
			}
			return (
				generateString() +
				generateString(true) +
				generateString(true) +
				generateString()
			);
		},
		clearErrorMessages() {
			if (this.alertIsVisible || this.serverErrorMessage) {
				this.alertIsVisible = false;
				this.serverErrorMessage = null;
				this.$store.commit('setErrorMessages', []);
			}
		},

		closeModalNewUser() {
			this.$emit('closeModalNewUser');
			this.importResult = null;
			this.importResultPartitions = null;
			this.showFileExtensionWarning = false;
			this.showImportInfo = true;
			this.studentData = [];
			this.validationCheck = false;
			this.clearErrorMessages();
		},

		addToList() {
			this.showImportInfo = false;
			this.validationCheck = false;

			this.studentData.push({
				entityGuid: this.generateEntityGuid()
			});
		},

		updateListObject(value, index) {
			this.studentData[index] = value;
		},
		deleteStudentField: function(index) {
			this.studentData.splice(index, 1);
		},
		validEmail: function(email) {
			var re = new RegExp(this.emailRegex);
			return re.test(email);
		},
		studentsDataIsInvalid() {
			return this.studentData.some(x => !x.firstName || !x.lastName);
		},
		async saveStudents() {
			this.validationCheck = true;
			this.clearErrorMessages();

			if (!this.studentsDataIsInvalid()) {
				this.requestMade = true;
				this.$emit('loadingStart');
				this.$emit('usersImportingStarted');

				const studentsList = JSON.parse(JSON.stringify(this.studentData));

				const response = await this.$apollo
					.mutate({
						mutation: gql`
							mutation($studentsList: [StudentAddInputObjectGraphType]) {
								addManyStudent(list: $studentsList) {
									firstName
									lastName
									email
									entityGuid
								}
							}
						`,
						variables: {
							studentsList: studentsList
						}
					})
					.catch(() => {
						const guid = this.$store.getters.errorMessagesGuids;
						this.studentData = this.studentData.filter(i => {
							return guid.includes(i.entityGuid);
						});
						this.$emit('usersImportingFinished');
						this.$emit('loadingStop');
						this.serverErrorMessage = this.$store.getters.errorMessages.join(
							' '
						);

						this.requestMade = false;
					});

				if (response) {
					this.$emit('usersImportingFinished');
					this.closeModalNewUser();
					this.clearErrorMessages();
					this.requestMade = false;
				} else {
					this.requestMade = false;
				}
			} else {
				this.alertIsVisible = true;
			}
		},
		handleFileUpload() {
			this.fileInput.value = null;
			this.fileInput.click();
		},
		startUpload(event) {
			this.importResult = null;
			this.importResultPartitions = null;
			this.$emit('loadingStart');

			const file = event.target.files[0];
			const fileNameArray = file.name.split('.');
			const fileExtension = fileNameArray[fileNameArray.length - 1];

			if (!fileConfigSettings.FILE_ALLOWED_TYPES.includes(fileExtension)) {
				this.showFileExtensionWarning = true;
				this.$emit('loadingStop');
				return;
			}

			this.showFileExtensionWarning = false;
			validateFileMaxLines(file, fileConfigSettings.FILE_MAX_LINES)
				.then(({ fileLines }) => {
					this.$emit('usersImportingStarted');
					// number of requests that have to be send
					const batchNumber = Math.ceil(
						fileLines / fileConfigSettings.FILE_MAX_LINES_PER_CHUNK
					);
					this.sendFile(file, batchNumber, 0);
				})
				.catch(e => {
					if (e.maxLinesError) {
						this.$emit('usersImportingFinished');
						this.$emit('loadingStop');
						this.importResult = {
							maxFileError: true
						};
					}
				});
		},
		sendFile(file, batchNumber, currentBatch) {
			const localBatchNumber = currentBatch;
			var formData = new FormData();
			formData.append('file', file);
			formData.append('totalBatchNumber', batchNumber);
			formData.append('currentBatchNumber', localBatchNumber);
			axios
				.post(`/api/Import/ImportStudents`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					withCredentials: true
				})
				.then(({ data }) => {
					if (data) {
						this.updateImportPartitions(data);
					}

					if (localBatchNumber < batchNumber - 1) {
						this.sendFile(file, batchNumber, localBatchNumber + 1);
						return;
					}

					this.$emit('usersImportingFinished');
					this.$emit('loadingStop');

					if (data) {
						this.importResult = this.importResultPartitions;
					}
				});
		},
		updateImportPartitions(data) {
			// create object properties if not exists
			if (!this.importResultPartitions) {
				this.importResultPartitions = {
					importedCount: 0,
					failedCount: 0,
					invalidRows: []
				};
			}

			if (data) {
				this.importResultPartitions.importedCount += data.importedCount;
				this.importResultPartitions.failedCount += data.failedCount;
				this.importResultPartitions.invalidRows = [
					...this.importResultPartitions.invalidRows,
					...data.invalidRows
				];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.add-student-modal {
	::v-deep .modal {
		min-height: 240px;
		max-height: 768px;
	}

	.page-content {
		flex-grow: 1;
		overflow-y: auto;
		padding: 0 5%;

		::v-deep .modal-wrapper {
			position: fixed;
		}
	}

	.close-button-new-student {
		height: 38px;
		width: 38px;
	}

	.modal-content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		min-height: 240px;
		max-height: 100%;
		margin: auto;
		margin-bottom: 48px;
		margin-top: 32px;
		overflow: initial;

		.title-modal {
			text-align: center;
			margin-bottom: 8px;
		}

		.import-info,
		.import-result,
		.file-extension-warning {
			text-align: center;
			margin-top: 8px;
			margin-bottom: 8px;

			.import-result-container {
				display: flex;
				justify-content: center;
				.import-result-imported,
				.import-result-failed {
					font-family: 'RobotoMedium';
					color: #00a391;
					margin-bottom: 8px;
					letter-spacing: 0.5px;
					@media (min-width: $breakpoint-mid) {
						font-size: 18px;

						.svg-icon {
							width: 24px;
							height: 24px;
						}
					}
					.svg-icon {
						margin-right: 10px;
					}
				}
				.import-result-failed {
					color: #f93457;
					margin-left: 10px;
				}
			}
			.import-result-failed-messages {
				color: #f93457;
				font-family: 'RobotoMedium';
				margin-bottom: 8px;
				letter-spacing: 0.5px;

				@media (min-width: $breakpoint-mid) {
					font-size: 18px;
				}
			}
		}
		.modal-content {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			max-height: 800px;

			.scrollbar {
				max-height: 600px;
			}

			.btn-import {
				margin-left: 16px;
			}
			#file-upload {
				display: none;
			}
		}
	}

	.fields-new-user {
		width: 70%;
		margin: auto;
		display: flex;
		flex-direction: column;
		div.new-user-row:not(:first-child) {
			border-top: 1px solid $button-border;
		}

		.alert-bar-students {
			word-break: break-word;
			border: 1px solid $alert-container-border-color;
			border-radius: 4px;
			padding: 8px;
		}

		.new-user-row {
			width: 100%;
			display: flex;
			flex-flow: row wrap;
			justify-content: center;

			@media (min-width: $breakpoint-mid) {
				justify-content: space-between;
			}

			.delete-student-field {
				color: $font-blue;
				height: 15px;
				width: 110px;
				font-family: 'RobotoMedium';
				margin: 10px;
				margin-bottom: 42px;

				.svg-icon {
					height: 24px;
					width: 24px;
					margin-right: 6px;
					color: $deleteStudentField;
				}
				@media (any-hover: hover) {
					&:hover {
						cursor: pointer;
						svg {
							fill: $hover-state;
						}
					}
				}
			}
		}
		.new-user-buttons {
			display: flex;
			width: 100%;
			align-items: center;
			flex-direction: column;
			margin-top: 32px;
			button {
				margin-bottom: 16px;
			}
			.add-another-student {
				margin-top: 16px;
			}
			.error-email {
				color: $error-state;
			}
		}
	}

	.second-row {
		margin-top: 16px;
	}

	::v-deep .alert-message {
		color: $deleteStudentField;
		font-family: 'RobotoRegular';
		font-size: 15px;
		letter-spacing: 0.5px;
		line-height: 23px;
	}

	::v-deep .delete-student-field:first-child {
		display: none;
	}

	::v-deep .alert-message {
		.svg-icon {
			margin-right: 6px;
			margin-top: -3px;
		}
	}

	.btn-done-container {
		display: flex;
		border-top: 1px solid $button-border;

		.btn-done-add-student {
			margin-bottom: -32px;
			margin-left: auto;
			margin-right: auto;
			margin-top: 16px;
			width: 110px;
		}
	}
}
</style>
